/* @ngInject */

export default ($rootScope, dateTimeService, Ownership) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function ReviewProductSplit(
    id,
    idParent,
    idProduct,
    productName,
    totalLoanAmount,
    totalLoanAmountWithLmi,
    lmi,
    isEditLmi,
    isCapitalize,
    lep,
    interestRateOfProduct,
    interestRate,
    interestRateDiscount,
    revertRateOfProduct,
    revertRate,
    revertRateDiscount,
    comparisonRate,
    fixedTerm,
    introTerm,
    interestOnlyTerm,
    loanTerm,
    cashback,
    offsetBalance,
    monthlyOffsetContribution,
    absLendingPurposeCode,
    fees,
    rewards,
    commissions,
    ownership,
    maximumBorrowing,
    selectedProduct
  ) {
    this.id = id;
    this.idParent = idParent;
    this.idProduct = idProduct;
    this.productName = productName;
    this.totalLoanAmount = totalLoanAmount;
    this.totalLoanAmountWithLmi = totalLoanAmountWithLmi;
    this.lmi = lmi;
    this.isEditLmi = isEditLmi;
    this.isCapitalize = isCapitalize;
    this.lep = lep;
    this.interestRateOfProduct = interestRateOfProduct;
    this.interestRate = interestRate;
    this.interestRateDiscount = interestRateDiscount;
    this.revertRateOfProduct = revertRateOfProduct;
    this.revertRate = revertRate;
    this.revertRateDiscount = revertRateDiscount;
    this.comparisonRate = comparisonRate;
    this.fixedTerm = fixedTerm;
    this.introTerm = introTerm;
    this.interestOnlyTerm = interestOnlyTerm;
    this.loanTerm = loanTerm;
    this.cashback = cashback;
    this.offsetBalance = offsetBalance;
    this.monthlyOffsetContribution = monthlyOffsetContribution;
    this.absLendingPurposeCode = absLendingPurposeCode;
    this.fees = fees;
    this.rewards = rewards;
    this.commissions = commissions;
    this.ownership = ownership;
    this.maximumBorrowing = maximumBorrowing;
    this.selectedProduct = selectedProduct;

    if (!this.interestRateOfProduct) {
      this.interestRateOfProduct = interestRate;
    }
    if (!this.revertRateOfProduct) {
      this.revertRateOfProduct = revertRate;
    }
    if (!this.selectedProduct?.residential?.rateType === 'FIXED' && this.fixedTerm) {
      this.introTerm = fixedTerm;
    }
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  ReviewProductSplit.Blank = function () {
    return ReviewProductSplit.Build({
      id: _.uuid(),
      idParent: '',
      idProduct: '',
      productName: '',
      totalLoanAmount: 0,
      totalLoanAmountWithLmi: 0,
      lmi: 0,
      isEditLmi: false,
      isCapitalize: false,
      lep: 0,
      interestRateOfProduct: 0,
      interestRate: 0,
      interestRateDiscount: 0,
      revertRateOfProduct: 0,
      revertRate: 0,
      revertRateDiscount: 0,
      comparisonRate: 0,
      fixedTerm: 0,
      introTerm: 0,
      interestOnlyTerm: 0,
      loanTerm: 0,
      cashback: 0,
      offsetBalance: 0,
      monthlyOffsetContribution: 0,
      absLendingPurposeCode: {
        id: '',
        value: ''
      },
      fees: {
        application: 0,
        valuation: 0,
        legal: 0,
        settlement: 0,
        packageMonthly: 0,
        packageAnnual: 0,
        rateLock: 0,
        other: 0
      },
      rewards: {
        hasRewards: false,
        description: '',
        points: 0
      },
      commissions: {
        loanAccountNumber: '',
        offsetAccountNumber: ''
      },
      ownership: [],
      maximumBorrowing: 0,
      selectedProduct: {}
    });
  };
  ReviewProductSplit.Build = function (data) {
    return new ReviewProductSplit(
      data.id ? data.id : _.uuid(),
      data.idParent ? data.idParent : '',
      data.idProduct ? data.idProduct : '',
      data.productName ? data.productName : '',
      data.totalLoanAmount ? data.totalLoanAmount : 0,
      data.totalLoanAmountWithLmi ? data.totalLoanAmountWithLmi : 0,
      data.lmi ? data.lmi : 0,
      data.isEditLmi ? data.isEditLmi : false,
      data.isCapitalize ? data.isCapitalize : false,
      data.lep ? data.lep : 0,
      data.interestRateOfProduct ? data.interestRateOfProduct : 0,
      data.interestRate ? data.interestRate : 0,
      data.interestRateDiscount ? data.interestRateDiscount : 0,
      data.revertRateOfProduct ? data.revertRateOfProduct : 0,
      data.revertRate ? data.revertRate : 0,
      data.revertRateDiscount ? data.revertRateDiscount : 0,
      data.comparisonRate ? data.comparisonRate : 0,
      data.fixedTerm ? data.fixedTerm : 0,
      data.introTerm ? data.introTerm : 0,
      data.interestOnlyTerm ? data.interestOnlyTerm : 0,
      data.loanTerm ? data.loanTerm : 0,
      data.cashback ? data.cashback : 0,
      data.offsetBalance ? data.offsetBalance : 0,
      data.monthlyOffsetContribution ? data.monthlyOffsetContribution : 0,
      !_.isEmpty(data.absLendingPurposeCode)
        ? data.absLendingPurposeCode
        : {
            id: '',
            value: ''
          },
      data.fees
        ? data.fees
        : {
            application: 0,
            valuation: 0,
            legal: 0,
            settlement: 0,
            packageMonthly: 0,
            packageAnnual: 0,
            rateLock: 0,
            other: 0
          },
      data.rewards
        ? data.rewards
        : {
            hasRewards: false,
            description: '',
            points: 0
          },
      data.commissions
        ? data.commissions
        : {
            loanAccountNumber: '',
            offsetAccountNumber: ''
          },
      _.compact(_.map(data.ownership, (obj) => Ownership.build(obj))),
      data.maximumBorrowing ? data.maximumBorrowing : 0,
      data.selectedProduct ? data.selectedProduct : {}
    );
  };

  return ReviewProductSplit;
};
